import { render } from "./PatientSearch.vue?vue&type=template&id=79d0e6a1&scoped=true"
import script from "./PatientSearch.vue?vue&type=script&lang=js"
export * from "./PatientSearch.vue?vue&type=script&lang=js"

import "./PatientSearch.vue?vue&type=style&index=0&id=79d0e6a1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d0e6a1"]])

export default __exports__